const segmentReports = {
    getList: 'SegmentReport/getlist',
    get: 'SegmentReport/get'
}

export default segmentReports